import React, { PureComponent } from 'react'
import Svg from 'react-native-svg'

export default class SVG extends PureComponent {
  render () {
    const { graphic, width, height, ...otherProps } = this.props
    const viewBoxWidth = graphic.width
    const viewBoxHeight = graphic.height
    const viewBoxRatio = viewBoxWidth / viewBoxHeight

    return (
      <Svg
        width={width || (height && parseInt(height * viewBoxRatio)) || 100}
        height={height || (width && parseInt(width / viewBoxRatio)) || 100}
        viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
        {...otherProps}
      >
        {graphic.content}
      </Svg>
    )
  }
}
